import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-[7px] rounded-full px-[11px] py-[4px] text-[13px] font-medium transition-colors duration-state focus:outline-none",
  {
    variants: {
      variant: {
        default: "bg-brand-wash text-brand-ink",
        secondary: "bg-inset text-ink-70",
        destructive: "bg-breach-wash text-breach-ink",
        outline: "bg-surface text-ink-70",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
